import { useEffect, useState } from "react";
import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { TemplatesTransport } from "src/app/transports/templates";

export interface ITemplatesOptions extends SimpleFormSelectOption {
    tag: string;
    text: string;
}

const useTemplatesOptions = (inicialRequest = true) => {
    const [templatesOptions, setTemplatesOptions] = useState<Array<ITemplatesOptions>>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const fetch = () => {
        setLoading(true);
        TemplatesTransport.findAll()
            .then((res) => {
                setTemplatesOptions(
                    res.map((el) => ({ label: el.title, value: el.id, tag: el.tag, text: el.text }))
                );
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        if (inicialRequest) fetch();
    }, []);

    return { templatesOptions, refresh, error, loading };
};

export default useTemplatesOptions;
